import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ServicesListComponent } from "./services-list/services-list.component"
import { QualifyProductComponent } from "./qualify-product/qualify-product.component"
import { NewServiceComponent } from "./new-service/new-service.component"
import { ThrowawayComponent } from "./throwaway/throwaway.component"
const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: 'services-list',  component : ServicesListComponent },
  { path: 'qualify-product',  component : QualifyProductComponent },
  { path: 'new-service',  component : NewServiceComponent },
  { path: 'throwaway',  component : ThrowawayComponent },
];
 
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes,{useHash:true})
  ],
  exports : [RouterModule],

  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/app-routing.module.ts